import { composeReducers } from 'common/util/composeReducers';
import { actionButtonPropertyReducer, actionButtonToggleModal } from 'common/reducers/actionButton';
import usersReducer from 'part11/reducers/users';
import groupsReducer from 'part11/reducers/groups';
import documentsReducer from 'part11/reducers/documents';
import storeSigningStatementsReducer from 'part11/reducers/signingStatements';
import userBulkAddReducer from 'part11/reducers/userBulkAdd';

const part11Reducer = composeReducers(
    usersReducer,
    groupsReducer,
    documentsReducer,
    actionButtonPropertyReducer,
    actionButtonToggleModal,
    storeSigningStatementsReducer,
    userBulkAddReducer
);
export default part11Reducer;
